/**
 * Article TOC + progressive accordion.
 *
 * Shopify's native article editor gives us article content as a single raw
 * HTML blob (whatever the merchant typed) — there's no per-section block
 * structure to hook into like our Standard Page template has. So instead of
 * requiring merchants to manually add anchor ids, this scans the rendered
 * content for <h2> headings at runtime and:
 *   1. Assigns each one a slug-based id
 *   2. Builds a numbered "On This Page" list (both the desktop sticky version
 *      and the mobile/tablet collapsible version) linking to those ids
 *   3. Optionally wraps each H2 section (from that H2 to the next one) in a
 *      <details> element, so later sections can start collapsed —
 *      configurable via data-open-count on the content container.
 *
 * Works with whatever content the merchant writes in Shopify's normal blog
 * editor, as long as they use H2 for section headings (already part of the
 * content guidelines).
 */
(function () {
  function slugify(text) {
    return (
      text
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .slice(0, 60) || 'section'
    );
  }

  function buildTOC() {
    var content = document.querySelector('[data-shatkona-article-content]');
    if (!content) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (headings.length < 2) return;

    var openCount = parseInt(content.dataset.openCount, 10);
    if (isNaN(openCount)) openCount = headings.length;

    var usedIds = {};
    var tocItems = [];

    headings.forEach(function (heading, index) {
      var baseId = 'shatkona-toc-' + slugify(heading.textContent);
      var id = baseId;
      var suffix = 1;
      while (usedIds[id]) {
        id = baseId + '-' + suffix;
        suffix += 1;
      }
      usedIds[id] = true;
      heading.id = id;

      tocItems.push({ id: id, label: heading.textContent, index: index });
    });

    // Populate both TOC containers (desktop sticky + mobile accordion) —
    // whichever exists on the page.
    ['[data-shatkona-article-toc-desktop]', '[data-shatkona-article-toc-mobile]'].forEach(function (selector) {
      var container = document.querySelector(selector);
      if (!container) return;
      var list = document.createElement('ul');
      list.setAttribute('role', 'list');
      tocItems.forEach(function (item) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + item.id;
        a.textContent = item.index + 1 + '. ' + item.label;
        li.appendChild(a);
        list.appendChild(li);
      });
      container.appendChild(list);
      container.hidden = false;
    });

    // Progressive accordion: wrap each section (H2 through the elements
    // before the next H2) in a <details>, open for the first `openCount`
    // sections, collapsed after that.
    headings.forEach(function (heading, index) {
      var isOpen = index < openCount;
      var details = document.createElement('details');
      if (isOpen) details.setAttribute('open', '');
      details.className = 'shatkona-article-section';

      var summary = document.createElement('summary');
      summary.className = 'shatkona-article-section__summary';
      summary.textContent = index + 1 + '. ' + heading.textContent;
      details.appendChild(summary);

      var body = document.createElement('div');
      body.className = 'shatkona-article-section__body';

      var node = heading.nextSibling;
      var nextHeading = headings[index + 1] || null;
      var toMove = [];
      while (node && node !== nextHeading) {
        var next = node.nextSibling;
        toMove.push(node);
        node = next;
      }

      heading.parentNode.insertBefore(details, heading);
      details.appendChild(body);
      toMove.forEach(function (n) {
        body.appendChild(n);
      });

      // The heading itself becomes redundant with the summary text, so hide
      // it visually but keep it for the anchor id / accessibility tree.
      heading.classList.add('visually-hidden');
      body.insertBefore(heading, body.firstChild);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildTOC);
  } else {
    buildTOC();
  }
})();
